// eslint-disable-next-line
export const asyncForEach = async (array: any[], callback: Function) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}

export const timeoutAsync = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export const isEmpty = (obj: {}) => {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false
    }
  }
  return true
}

/**
 * Check if the parameters are matching the definition
 * @param definitions: parameters definitions (based on config.api.endpoints..definition)
 * @param parameters: parameters to test
 */
export const matchDefinition = (definitions: { [key: string]: string }, parameters: { [key: string]: string }): boolean => {
  for (const definition in definitions) {
    if (!Object.prototype.hasOwnProperty.call(parameters, definition)) {
      return false
    }
    const type = definitions[definition]
    const value = parameters[definition]
    if (type !== typeof value) {
      return false
    }
  }
  return true
}

/**
 * Return content from url
 * @param url Url
 * @returns Content from url
 */
export const fetchAsync = async (url: string) => {
  return fetch(url).then((response) => {
    if (response.status >= 200 && response.status < 300) {
      return Promise.resolve(response)
    } else {
      const error = new Error(`Error fetching ${url}: response status = ${response.status}`)
      return Promise.reject(error)
    }
  })
}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const initializeObject = (keys: string[], defaultValue: any): { [key: string]: any } => {
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  const object: { [key: string]: any } = {}
  keys.forEach(key => {
    object[key] = defaultValue
  })
  return object
}
